
import { Component, Vue, Watch } from 'vue-property-decorator';
import timestatistical from "./components/timestatistical.vue"
import lineCharts from "./components/line-charts.vue"
import {
	dataStatisdataStatisMemberAnalysis
} from "@/api/material"
import {
	getSearchDate,
	nextDay
} from "@/utils"
import Dialog from '@/components/dialog.vue';
import { imgHost } from '@/utils/config';
import { Form } from 'element-ui';
@Component({
	name: '',
	components: {
		timestatistical,
		lineCharts,
		'slz-dialog': Dialog,
	}
})

export default class ProductList extends Vue {
	private explainShow = false
	private up = 'http://cdn2024.routuan.com/routuan/image/dataAnalysis-up.png'
	private down = 'http://cdn2024.routuan.com/routuan/image/dataAnalysis-down.png'
	private userloading = false
	private type1 = 1;
	private time1: any = []
	private linedata1: any = []
	private linedata2: any = []
	private lines1: any = []
	private lines2: any = []
	private msg: any = {}
	private compare = [
		{ type: 1, label: '较前一日' },
		{ type: 2, label: '较前一周' },
		{ type: 3, label: '较前一月' },
		{ type: 4, label: '较前7天' },
		{ type: 5, label: '较前30天' },
	];

	private isToday = true;

	@Watch('type1')
	private type1Change(newd, oldd) {
		this.checkIsToday();
	}
	@Watch('time1')
	private time1Change(newd, oldd) {
		this.checkIsToday();
	}

	private mounted() {
		this.time1 = getSearchDate(2)
		this.getData()
	}

	private checkIsToday(){
		if (this.type1 === 1){
			let dt = new Date();
			let year = dt.getFullYear();
			let month = dt.getMonth();
			let day = dt.getDate();

			if (new Date(year, month, day).getTime() === new Date(this.time1[0].split('-').join('/')).getTime()){
				this.isToday = true;
			}else{
				this.isToday = false;
			}
		}else{
			this.isToday = false;
		}
	}

	private gettime(e, num) {
		let type = 'type' + num
		let time = 'time' + num
		this[type] = e.type
		this[time] = e.time
		this.getData()
	}
	private async getData() {
		try {
			this.userloading = true
			let data: any = {
				TimeType: this.type1,
				StartDate: this.time1[0],
				EndDate: this.time1[1]
			}
			//如果查的是今天 type为0 时间为空
			let istoday = new Date(this.time1[0]).getTime() == new Date(getSearchDate(2)[0]).getTime()
			if (this.type1 == 1 && istoday) {
				data.TimeType = 0
				data.StartDate = ''
				data.EndDate = ''
			}
			let res = await dataStatisdataStatisMemberAnalysis(data)
			if (res.IsSuccess) {
				this.msg = res.Result
				this.lines1 = [
					{ key: 'VisitTotalMemberNum', name: '访问用户', defaultshow: true },
					{ key: 'VisitMemberNum', name: '访问用户(团长)', defaultshow: false },
					{ key: 'VisitCustomerNum', name: '访问用户(客户)', defaultshow: false },
					{ key: 'OrderTotalMemberNum', name: '下单用户', defaultshow: true },
					{ key: 'OrderMemberNum', name: '下单用户(团长)', defaultshow: false },
					{ key: 'OrderCustomerNum', name: '下单用户(客户)', defaultshow: false },
				]
				this.lines2 = [
					{ key: 'AddCustomerNum', name: '新增客户' },
					{ key: 'AddMemberNum', name: '新增团长' },
				]
			}
		} finally {
			this.userloading = false
		}
	}
	private noinus(num: number) {
		if (num < 0) {
			let str = num + ''
			return str.substring(1, str.length)
		}
		return num || 0
	}
}
